import axios from "axios";

const api_endpoint = process.env.API_ENDPOINT;

export const chatHistory = async (id_token, username)=>{
  try {
    const response = await axios.get(
      api_endpoint + `/chat-history?username=${username}`,
      {
        headers: {
            'AUthorization' : id_token,
          }
      }
    );
    // console.log("Chat History Response:", response.data.chat_history);
    return response.data.chat_history
  } catch (error) {
    console.error("Error fetching chat history:", error);
  }
}

// export const ChatHistory = () => {
//   const [history, setHistory] = useState([]);
  
//   useEffect(() => {
//     const fetchChatHistory = async () => {
//       try {
//         const response = await axios.get(api_endpoint + `/chat-history?username=${username}`);
//         console.log("Chat History Response:", response.data.chat_history);

//         setHistory(response.data.chat_history);
//       } catch (error) {
//         console.error("Error fetching chat history:", error);
//       }
//     };

//     fetchChatHistory();
//   }, []); 

//   return (
    
//   );
// };

export const chat = async (id_token, username, chat_id)=>{
  try {
    const response = await axios.get(
      api_endpoint + `/chat-history?username=${username}&chat_id=${chat_id}`,
      {
        headers: {
            'AUthorization' : id_token,
          }
      }
    );
    // console.log("Chat History Response:", response.data.chat_history);

    return response.data.chat_history
  } catch (error) {
    console.error("Error fetching chat history:", error);
  }
}

export const deleteChat = async (id_token, username, chat_id)=>{
  try {
    const response = await axios.get(
      api_endpoint + `/chat-history?username=${username}&chat_id=${chat_id}&action=del`,
      {
        headers: {
            'AUthorization' : id_token,
          }
      }
    );
    // console.log("Chat successfully deleted:", response.data);

  } catch (error) {
    console.error("Failed to delete the chat:", error);
  }
}

